// Use $ instead of $ without replacing global $
(function ($) {

  function iPad() {
    $('.ua-mobile .header .list-item > .solutions > a').click(function (e) {
      e.preventDefault();
    });

    $('.ua-mobile .header .list-item > .resources > a').click(function (e) {
      e.preventDefault();
    });
  }

  $(".header .inner-nav").hover(function () {
    $(this).addClass("active");
  }, function () {
    $(this).removeClass("active");
  });

  function show_menu() {
    $('.header .inner-nav > a, header .inner-nav > span ').click(function (e) {
      var window_width = $(window).width();
      if (window_width <= 991) {
        e.stopPropagation();
        e.preventDefault();
        $('.header .sub-menu').not($(this).siblings('.sub-menu')).slideUp();
        $(this).siblings('.sub-menu').stop(true, true).slideToggle();
        $(this).parent().toggleClass('menu-active');
        $(this).parent().siblings('.inner-nav').removeClass('menu-active');
      }
    });
  }

  $(window).on('load', function () {
    if ($(this).scrollTop() > 0) {
      $(".header").addClass("fixed");
    } else {
      $(".header").removeClass("fixed");
    }
  });

  $(document).ready(function () {
    show_menu();
    iPad();

    $(window).scroll(function () {
      if ($(this).scrollTop() > 0) {
        $(".header").addClass("fixed");
      } else {
        $(".header").removeClass("fixed");
      }
    });

    $(".header .humberger").click(function () {
      $(".header .humberger").toggleClass("active");
      $(".header nav").slideToggle();
      $('.header .sub-menu').slideUp();
      $(".header").toggleClass("active");
      $(".header nav .list-item > li.inner-nav").removeClass("rotate-arrow");
      $(".header nav .list-item > li.inner-nav").removeClass("menu-active");
    });

    // Remove classes on window resize
    $(window).on("resize", function () {
      var window_width = $(window).width();
      if (window_width > 991) {
        $(".header .humberger").removeClass("active");
        $(".header").removeClass("active");
        $(".header").removeClass("fixed");
        $(".header nav .list-item > li.inner-nav").removeClass("rotate-arrow");
        $(".header nav .list-item > li.inner-nav").removeClass("menu-active");
        $(".header nav .sub-menu").removeAttr("style");
        $(".header nav").removeAttr("style", "");
      }
    });
  });
})(jQuery);
